import { mapActions, mapGetters, mapMutations } from 'vuex'

import { productMovesUtil, currencyUtil, commonUtil } from '@/util'

import DisplaySwitchButton from '@/components/items/Buttons/DisplaySwitchButton'
import HelpCircle from '@/components/items/Buttons/HelpCircle'
import CsvHistoryTable from '@/components/items/Tables/CsvHistoryTable'

import CsvRowInfo from './RowInfo'

import mutationTypes from '@/store/mutationTypes'

export default {
  name: 'HistoryList',
  components: {
    DisplaySwitchButton,
    HelpCircle,
    CsvHistoryTable,

    CsvRowInfo
  },
  props: {
    isOperation: { default: false },
    summary: {
      type: Object,
      require: false,
      default: () => ({})
    },
    historyList: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: '',

    headers: {
      type: Array,
      require: true,
      default: () => []
    },
    productListHeaders: {
      type: Array,
      require: true,
      default: () => []
    },
    isFooter: { type: Boolean, default: false },
    hiddenHeaderOperation: { type: Boolean, default: false },
    pagerKey: {
      type: String,
      default: ''
    },
    isCheckedAllSelect: { default: false }

    // customerList: {
    //   default: {}
    // }
  },
  data: () => ({
    openPanelIndex: [],
    allChangeCheckBox: false,
    productInfoData: [],
    selectRowInfo: {
      selectRowlength: 0,
      sumAmount: 0,
      unit: ''
    },

    operationName: '',
    isBatch: false,

    currencyAmountSelect: [],
    currencyAmount: [],

    componentNames: {
      BulkOperationButtons: '',
      RowInfo: '',
      RowInfoDetail: ''
    },
    customerList: [],
    supplierList: [],

    dialogParams: {
      dialog: false,
      type: '',
      items: null,
      submitPath: '',
      submitFunc: () => {}
    }
  }),
  // beforeMount() {
  //    this.setProductInfoData()
  // },
  async created() {},
  methods: {
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    ...mapMutations('UI', [mutationTypes.UI_SET_PAGE]),

    panelClick(index) {
      this.openPanelIndex.find((ele) => ele === index)
        ? (this.openPanelIndex = this.openPanelIndex.filter(
            (ele) => ele !== index
          ))
        : this.openPanelIndex.push(index)
    },

    getProductInfoData(id) {
      return this.productInfoData.find((ele) => ele.id === id)
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },

    pageReload() {
      this.$emit('pageReload')
    },

    changeCheckBoxCommon() {
      this.setSelectRowlength()
      this.setPriceForCostAmount()
    },
    changeAllCheckBox(bool) {
      this.productInfoData.map((ele) => {
        ele.checkFlg = bool
        return ele
      })
      this.changeCheckBoxCommon()
    },
    changeProductTableCheckbox() {
      this.$emit('changeProductTableCheckbox')
    },
    allCheckProductTable(args) {
      this.$emit('allCheckProductTable', args)
    },
    setSelectRowlength() {
      const count = this.productInfoData.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.checkFlg ? 1 : 0
          return accumulator + count
        },
        0
      )
      this.selectRowInfo.selectRowlength = count
      this.allChangeCheckBox = this.productInfoData.length === count
    },
    setPriceForCostAmount() {
      const count = this.productInfoData.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.checkFlg
            ? currentValue.priceForCostAmount
            : 0
          return accumulator + count
        },
        0
      )
      this.selectRowInfo.sumAmount = count
    },

    dialogReload() {
      this.$emit('dialogReload')
    },
    getCurrencyName(productInfo) {
      const currencyId = productInfo.currencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },
    pageMove() {
      this.allChangeCheckBox = false
      this.selectRowInfo.selectRowlength = 0
      this.selectRowInfo.sumAmount = 0
      this.$emit('pageMove')
    }
  },

  computed: {
    ...mapGetters('UI', ['pageInfo']),
    page: {
      get() {
        return this.pageInfo[this.pagerKey].page
      },
      set(index) {
        this[mutationTypes.UI_SET_PAGE]({ index, key: this.pagerKey })
      }
    },
    pageCount() {
      return this.pageInfo[this.pagerKey].pageCount
    }
  },

  watch: {
    historyList: function (val) {
      this.openPanelIndex = []
    }
  }
}
